export default {
  name: 'pc-news-card',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '新闻咨询',
          icon: 'el-icon-chat-line-round',
          content: {
            title: '最新咨询',
            link: {},
            list: []
          },
          config: [{
            label: '标题',
            name: 'title',
            type: 'input',
            value: '最新咨询'
          }, {
            label: '更多链接',
            name: 'link',
            type: 'link',
            value: ''
          }, {
            label: '列表数据',
            name: 'list',
            type: 'mapList',
            value: [],
            attrs: {
              name: {
                label: '标题',
                value: 'label'
              },
              img: {
                label: '图片',
                value: 'img'
              },
              link: {
                label: '跳转链接',
                value: 'link'
              }
            }
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};